module.exports = __webpack_public_path__ + "static/assets/23d5956ad3641d4663a17353c71477b0.mp3";